import { filter, some, startsWith } from 'lodash';
export const OrganisationStructure = 'OrganisationStructure';
export const OrgStructureLevel = 'OrgStructureLevel';
export const ProgramXOrgStructLevel = 'ProgramXOrgStructLevel';
export const ProgramGroup = 'ProgramGroup';
export const isOrganisationStructure = ({ __typename }) => __typename === OrganisationStructure;
export const isOrgStructureLevel = ({ __typename }) => __typename === OrgStructureLevel;
export const isProgramXOrgStructLevel = ({ __typename }) => __typename === ProgramXOrgStructLevel;
export const isProgramGroup = ({ __typename }) => __typename === ProgramGroup;
export const selectionFilter = programs => filter(programs, isProgramXOrgStructLevel);
export const nodeIsSelectable = isProgramXOrgStructLevel;
export const nodeIsLeaf = node => isProgramXOrgStructLevel(node);
export const canRender = ({ id, model, leaf, nodesMeta: { hasChild }, state, }) => {
    const checkLeafExistsRecursively = (nodeId) => {
        if (!state.children[nodeId] || !state.children[nodeId].length) {
            return false;
        }
        const leafExists = some(state.children[nodeId], str => startsWith(str, ProgramXOrgStructLevel) &&
            !Object.keys(state.hiddenNodeIds).find(x => x === str));
        if (leafExists) {
            return true;
        }
        return some(state.children[nodeId], childId => checkLeafExistsRecursively(childId));
    };
    if ((model.id !== ':ROOT:' || model.id !== null) && !nodeIsLeaf(model)) {
        if (state.children[id]) {
            const leafExists = checkLeafExistsRecursively(id);
            if (!leafExists || leaf) {
                return false;
            }
        }
        else {
            return false;
        }
    }
    return true;
};
export const resolveNodeParentIdRoot = node => {
    if (isOrganisationStructure(node)) {
        return null;
    }
    if (isOrgStructureLevel(node) && !node.parentId) {
        return `${OrganisationStructure}-${node.organisationStructureId}`;
    }
    if (isOrgStructureLevel(node) && node.parentId) {
        return `${OrgStructureLevel}-${node.parentId}`;
    }
    if (isProgramXOrgStructLevel(node) && node.organisationStructureLevelId) {
        return `${OrgStructureLevel}-${node.organisationStructureLevelId}`;
    }
    if (isProgramXOrgStructLevel(node) && node.orgStructureId) {
        return `${OrganisationStructure}-${node.orgStructureId}`;
    }
    return node.parentId || null;
};
export default {
    nodeIsLeaf,
    resolveNodeId: node => {
        if (isOrganisationStructure(node)) {
            return `${OrganisationStructure}-${node.id}`;
        }
        if (isOrgStructureLevel(node)) {
            return `${OrgStructureLevel}-${node.id}`;
        }
        if (isProgramXOrgStructLevel(node)) {
            return `${ProgramXOrgStructLevel}-${node.id}`;
        }
        if (isProgramGroup(node)) {
            return `${ProgramGroup}-${node.id}`;
        }
        return node.id;
    },
    resolveNodeParentId: node => {
        if (isOrganisationStructure(node)) {
            return node.programGroupId
                ? `${ProgramGroup}-${node.programGroupId}`
                : null;
        }
        if (isOrgStructureLevel(node) && !node.parentId) {
            return `${OrganisationStructure}-${node.organisationStructureId}`;
        }
        if (isOrgStructureLevel(node) && node.parentId) {
            return `${OrgStructureLevel}-${node.parentId}`;
        }
        if (isProgramXOrgStructLevel(node)) {
            return `${OrgStructureLevel}-${node.organisationStructureLevelId}`;
        }
        return node.parentId || null;
    },
};
